import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    spaceId: String,
    url: String,
  };

  static targets = ["input"];

  connect() {
    this.loadBlocks();
  }

  blur(e) {
    console.log("blur", e);
    e.target.blur();
  }

  loadBlocks() {
    const date = this.inputTarget.value;
    if (!date) return;

    const url = new URL(this.urlValue);
    url.searchParams.set("start_at", date);

    fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((r) => r.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
